import { ApiCreditcard } from '@/models/api/creditcard'
import {
  CreditcardRepository,
  FrontAPICreditCardRepository,
  RegisterContext,
} from '@/models/payment/creditcard/repository/creditcard-repository'
import { CreditcardServiceForPurchase } from '@/services/api/creditcard'
import { CreditcardPaymentProviderServiceForPurchase } from '@/services/payment/creditcard-payment-provider/creditcard-payment-provider-service'
import { CreditcardFormState } from '@spa/components/organisms/payment/creditcard/creditcardFormState'
import { User } from '@spa/store/modules/user/types'
import { identity } from 'fp-ts/lib/function'
import { none } from 'fp-ts/lib/Option'
import { ActionRequest } from '../../action/action'
import {
  CreditcardAuthenticationError,
  InvalidCreditcardNumberError,
  LoadingCreditcardSciptError,
  UnknownCreditcardRegisterError
} from '../../repository/errors'

export interface CreditcardForPurchaseRepository extends CreditcardRepository {
  listRegistered(): Promise<ApiCreditcard[]>
}

export class FrontApiRepositoryForPurchase
  extends FrontAPICreditCardRepository<CreditcardServiceForPurchase, CreditcardPaymentProviderServiceForPurchase>
  implements CreditcardForPurchaseRepository {

  /**
   *
   * @param creditcard
   * @param user
   * @param context purchase文脈での実装であるため、someを渡しても動作に影響はなく無視される。
   * 文脈透過的なAPIサービス層を利用しているため、このような実装になっている。
   * @returns Promise<ActionRequest>
   */
  async register(
    creditcard: CreditcardFormState,
    user: User,
    context: RegisterContext = { threeDSecureRedirectUrl: none, threeDSecureExtraProfile: none }
  ): Promise<ActionRequest> {
    {
      await this.scriptLoading.catch((e: Error) => {
        throw new LoadingCreditcardSciptError(e.message)
      })

      // スクリプトの取得が終わったことを確定させてから、後続処理を実行
      const paymentResult = await this.cardPaymentProvider.createRegisterCardPayload(
        creditcard,
        user
      )

      const token = paymentResult.fold(
        (e) => {
          throw new CreditcardAuthenticationError(e.message)
        },
        identity
      )

      const result = await this.creditCardService.create(
        token,
        context.threeDSecureRedirectUrl,
        context.threeDSecureExtraProfile
      )

      return result.fold(
        (r: any) => {
          const message = r.response.body.message

          switch (message) {
            case 'invalid_card':
              throw new InvalidCreditcardNumberError()
            default:
              throw new UnknownCreditcardRegisterError()
          }
        },
        () => ({
          name: 'no-action',
        }
      ))
    }
  }

  listRegistered(): Promise<ApiCreditcard[]> {
    return this.creditCardService.list().then(result => result.fold(
      e => Promise.reject(e),
      ls => Promise.resolve(ls)
    ))
  }
}
